import { useEffect, useState } from 'react';
import axios from 'axios';

const bearerConfig = () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

const responseDetail = async (error, fallback) => {
  const payload = error?.response?.data;
  if (payload instanceof Blob) {
    try {
      const parsed = JSON.parse(await payload.text());
      return parsed?.detail || fallback;
    } catch {
      return fallback;
    }
  }
  return payload?.detail || fallback;
};

export const fetchProtectedDocument = async (url) => {
  try {
    const response = await axios.get(url, { ...bearerConfig(), responseType: 'blob' });
    return response.data;
  } catch (error) {
    const message = await responseDetail(error, 'No fue posible cargar el documento.');
    const protectedError = new Error(message);
    protectedError.status = error?.response?.status;
    throw protectedError;
  }
};

export const downloadProtectedDocument = async (url, filename) => {
  const blob = await fetchProtectedDocument(url);
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
};

export const useProtectedDocumentUrl = (url, enabled = true) => {
  const [state, setState] = useState({ url: '', loading: false, error: '' });

  useEffect(() => {
    let active = true;
    let objectUrl = '';
    if (!url || !enabled) {
      setState({ url: '', loading: false, error: '' });
      return undefined;
    }

    setState({ url: '', loading: true, error: '' });
    fetchProtectedDocument(url)
      .then((blob) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(blob);
        setState({ url: objectUrl, loading: false, error: '' });
      })
      .catch((error) => {
        if (active) setState({ url: '', loading: false, error: error.message });
      });

    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url, enabled]);

  return state;
};
